export const FEATURE_NAME = '@zerops/zerops/feature/token-display-dialog';
